import { render, staticRenderFns } from "./HowTo.vue?vue&type=template&id=65212cad&scoped=true&"
import script from "./HowTo.vue?vue&type=script&lang=js&"
export * from "./HowTo.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/static-pages/howto.scss?vue&type=style&index=0&id=65212cad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65212cad",
  null
  
)

export default component.exports